import { Building } from "../building/building.model";
import { UserBasic } from "../../_models/user.model";
import { AttachmentImage } from "src/app/_models/image.model";

export class Report {
    id: number;
    title: string;
    description: string;
    number: string;
    category: number;
    priority: number;
    idUserCreatedBy: number;
    createdAt: string;
    endedAt: string;
    startedAt: string;
    status: number;
    idGroup: number;
    idBuilding: number;
    type: number;
    system: number;
    idFloor: number;
    createdBy: UserBasic;
    building: Building;
    images: AttachmentImage[] = [];
}

